<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          dark
          small
          :label="title"
          :aria-label="title"
          flat
          color="white"
          v-on="on"
          @click="toggleContent"
          class="white--text drawer-button"
        >
          <v-icon
            v-if="icon"
            class="drawer-icon"
            dark
          >{{ icon }}</v-icon>
          <span
            v-if="text"
            style="font-weight: bold"
          >{{ text }}</span>
        </v-btn>
        <v-fade-transition>
          <div
            v-show="active"
            class="drawer-icon-active"
          ></div>
        </v-fade-transition>
      </template>
      <span>{{ title }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "LeftSidebarItemToggle",
  computed: {
    ...mapState(["showSideMenu"])
  },
  props: {
    name: String,
    icon: String,
    active: Boolean,
    text: String,
    title: String
  },
  methods: {
    ...mapActions(["setShowSideMenu"]),
    toggleSidemenu: function () {
      this.setShowSideMenu(!this.showSideMenu);
    },
    toggleContent: function () {
      this.$emit("toggle-tool", this.name);
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-button {
  margin-bottom: 10px;
  margin-top: 10px;
}

.drawer-icon {
  font-size: 22px !important;
}

.drawer-icon-active {
  padding-left: 5px;
  margin-left: 14px;
  margin-right: 14px;
  margin-top: -15px;
  margin-bottom: 12px;
  border-bottom: 3px solid deepskyblue;
}
</style>
